import Vue from 'vue';
import axios from 'axios';
import '../../filters';
import moment from 'moment';
import users from '../../users';

const toLower = (text) => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    return items.filter((item) => toLower(item.name).includes(toLower(term)));
  }

  return items;
};

export default {
  name: 'createApplication',
  mixins: [users],
  components: {
    StationDeclaredDialogs: require('@/customcontrols/stationDeclaredDialogs/stationDeclaredDialogs.vue').default
  },
  data: function () {
    return {
      stationDeclaredDialog: false,
      applicationTypes: [],
      search: null,
      searched: [],
      selectedType: {},
      typesGroups: [],
      isOm: false
    };
  },
  computed: {},
  watch: {},
  created() {
    this.isOm = this.$route.query.mod && this.$route.query.mod === 'om';
    this.getApplicationTypes();
  },
  methods: {
    getApplicationTypes() {
      var parameter = { Module: this.isOm === true ? 2 : 1 };
      //this.$store.state.notifier.asyncBlock(
      axios
        .post('/EmployeeApplication/GetApplicationTypes', parameter)
        .then((resp) => {
          this.applicationTypes = resp.data.items;
          this.searched = this.applicationTypes;
          this.fillAppTypesGroups();
        })
        .catch((err) =>
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text)
        );
    },
    fillAppTypesGroups() {
      this.typesGroups = [];

      for (var i = 0; i < this.searched.length; i++) {
        if (this.typesGroups.filter((a) => a.groupId == this.searched[i].groupId).length == 0) {
          this.typesGroups.push({
            groupId: this.searched[i].groupId,
            groupName: this.searched[i].groupName,
            extended: this.typesGroups.length == 0 ? true : false
          });
        }
      }
    },
    searchOnTable() {
      this.searched = searchByName(this.applicationTypes, this.search);

      this.fillAppTypesGroups();
    },
    onSelect(item) {
      this.selectedType = item;
    },
    createApplicationChecks() {
      if (this.selectedType.id == undefined) {
        this.$alertMsg(this.$t('messages.youShouldSelectAnApplicationType'), 3);
        return;
      }

      let stations = this.$store.getters.getUserStations;

      if (
        stations &&
        stations.assigned &&
        stations.assigned.id > -1 &&
        stations.declared &&
        stations.declared.id > -1 &&
        stations.assigned.id != stations.declared.id
      ) {
        //this.applicationStationName = stations.declared.id;
        this.stationDeclaredDialog = true;

        setTimeout(() => {
          this.createApplication();
        }, 3000);
      } else this.createApplication();
    },
    createApplication() {
      let stations = this.$store.getters.getUserStations;
      let stationId = stations.declared.id > -1 ? stations.declared.id : stations.assigned.id;

      let parameter = {
        Value: this.selectedType.id,
        Module: this.isOm === true ? 2 : 1,
        StationId: stationId
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/EmployeeApplication/CreateApplication', parameter),
        (response) => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.applicationHasBeenCreatedSuccessfully'), 2);
            this.$router.push('/application/' + response.data.applicationId);
          } else {
            this.$alertMsg(response.data.data.text);
          }
        },
        (err) =>
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text)
      );
    },
    rowDblClickHandler(item) {
      this.selectedType = item;
      this.createApplicationChecks();
    }
  }
};
